import { render } from "./kgo_remaining.vue?vue&type=template&id=40e28054&scoped=true"
import script from "./kgo_remaining.vue?vue&type=script&lang=js"
export * from "./kgo_remaining.vue?vue&type=script&lang=js"

import "./kgo_remaining.vue?vue&type=style&index=0&id=40e28054&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e28054"]])

export default __exports__